import { getTempData, setTempData } from "./persistenceStorage";

const sessionIdKey = "sessionId";

export const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
const oldSessionId = getTempData(sessionIdKey, null);
export const sessionId = oldSessionId ? oldSessionId : generateUUID();
setTempData(sessionIdKey, sessionId);



// WEBPACK FOOTER //
// ./src/utils/session.js